import React, { useEffect, createElement } from 'react';
import { CheckCircleIcon, AlertTriangleIcon, BotIcon, LightbulbIcon, SmartphoneIcon, RocketIcon, ZapIcon, CalendarIcon, PhoneIcon, MapPinIcon, PenLineIcon, MailIcon, QuoteIcon, StarIcon } from 'lucide-react';
import { Footer } from '../components/Footer';
import { WhatsAppButton } from '../components/WhatsAppButton';
declare global {
  interface Window {
    fbq: any;
  }
}
export function LlamadaConfirmationPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
    (function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js', null, null, null);
    window.fbq('init', '754551913878347');
    window.fbq('track', 'Schedule');
  }, []);
  return <div className="min-h-screen bg-black text-white font-sans overflow-x-hidden" data-id="element-1918">
      {/* Meta Pixel Noscript */}
      <noscript data-id="element-1919">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=754551913878347&ev=Schedule&noscript=1" alt="" data-id="element-1920" />
      </noscript>

      {/* HERO BANNER */}
      <div className="bg-gradient-to-r from-[#00f7fc]/20 to-[#00d7dc]/10 border-b border-[#00f7fc]/30 py-10 md:py-16 px-4" data-id="element-1921">
        <div className="max-w-3xl mx-auto text-center" data-id="element-1922">
          <div className="flex justify-center mb-5" data-id="element-1923">
            <div className="w-20 h-20 bg-[#00f7fc]/10 border-2 border-[#00f7fc] rounded-full flex items-center justify-center" data-id="element-1924">
              <CheckCircleIcon className="w-10 h-10 text-[#00f7fc]" data-id="element-1925" />
            </div>
          </div>
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-black uppercase leading-tight tracking-tight mb-4" data-id="element-1926">
            Tu Llamada Está <span className="text-[#00f7fc]" data-id="element-1927">Confirmada</span>
          </h1>
          <p className="text-base md:text-lg text-gray-300 flex items-center justify-center gap-2" data-id="element-1928">
            <MailIcon className="w-5 h-5 text-[#00f7fc] flex-shrink-0" data-id="element-1929" />
            Revisa tu email para los detalles de conexión
          </p>
        </div>
      </div>

      <main className="max-w-4xl mx-auto px-4 py-10 md:py-16 space-y-12 md:space-y-16" data-id="element-1930">
        {/* IMPORTANT WARNING */}
        <section data-id="element-1931">
          <div className="bg-yellow-500/10 border-2 border-yellow-500/40 rounded-2xl p-6 md:p-8" data-id="element-1932">
            <div className="flex items-start gap-4" data-id="element-1933">
              <div className="flex-shrink-0 w-10 h-10 bg-yellow-500/20 rounded-full flex items-center justify-center" data-id="element-1934">
                <AlertTriangleIcon className="w-5 h-5 text-yellow-400" data-id="element-1935" />
              </div>
              <div data-id="element-1936">
                <h2 className="text-lg md:text-xl font-black uppercase tracking-wide text-yellow-400 mb-2" data-id="element-1937">
                  IMPORTANTE: Lee Esto Antes de Cerrar Esta Página
                </h2>
                <p className="text-gray-200 text-base md:text-lg leading-relaxed" data-id="element-1938">
                  Estás A <span className="font-black text-white" data-id="element-1939">UN PASO</span>{' '}
                  de Descubrir El Sistema de IA Que Está Cambiando Negocios en
                  Miami
                </p>
                <p className="text-gray-400 mt-3 text-sm md:text-base leading-relaxed" data-id="element-1940">
                  En tu llamada, te mostraremos exactamente cómo usar
                  herramientas de inteligencia artificial para construir un
                  negocio digital real, desde cero, sin experiencia previa.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* WHAT WILL HAPPEN ON YOUR CALL */}
        <section data-id="element-1941">
          <div className="text-center mb-8" data-id="element-1942">
            <div className="inline-flex items-center gap-2 bg-[#00f7fc]/10 border border-[#00f7fc]/30 rounded-full px-4 py-2 mb-4" data-id="element-1943">
              <CheckCircleIcon className="w-4 h-4 text-[#00f7fc]" data-id="element-1944" />
              <span className="text-sm font-semibold text-[#00f7fc] uppercase tracking-wide" data-id="element-1945">
                Lo Que Va a Pasar En Tu Llamada
              </span>
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-4" data-id="element-1946">
            <div className="bg-gray-900/60 border border-gray-800 rounded-xl p-5 flex items-start gap-4" data-id="element-1947">
              <div className="flex-shrink-0 w-10 h-10 bg-[#00f7fc]/10 rounded-lg flex items-center justify-center" data-id="element-1948">
                <BotIcon className="w-5 h-5 text-[#00f7fc]" data-id="element-1949" />
              </div>
              <p className="text-gray-200 text-sm md:text-base leading-relaxed" data-id="element-1950">
                Te mostraremos el sistema exacto de{' '}
                <span className="font-bold text-white" data-id="element-1951">
                  48 Horas AI Cash Machine
                </span>
              </p>
            </div>

            <div className="bg-gray-900/60 border border-gray-800 rounded-xl p-5 flex items-start gap-4" data-id="element-1952">
              <div className="flex-shrink-0 w-10 h-10 bg-[#00f7fc]/10 rounded-lg flex items-center justify-center" data-id="element-1953">
                <LightbulbIcon className="w-5 h-5 text-[#00f7fc]" data-id="element-1954" />
              </div>
              <p className="text-gray-200 text-sm md:text-base leading-relaxed" data-id="element-1955">
                Aprenderás cómo la IA puede{' '}
                <span className="font-bold text-white" data-id="element-1956">
                  transformar tu negocio
                </span>{' '}
                desde hoy
              </p>
            </div>

            <div className="bg-gray-900/60 border border-gray-800 rounded-xl p-5 flex items-start gap-4" data-id="element-1957">
              <div className="flex-shrink-0 w-10 h-10 bg-[#00f7fc]/10 rounded-lg flex items-center justify-center" data-id="element-1958">
                <SmartphoneIcon className="w-5 h-5 text-[#00f7fc]" data-id="element-1959" />
              </div>
              <p className="text-gray-200 text-sm md:text-base leading-relaxed" data-id="element-1960">
                Todo desde tu{' '}
                <span className="font-bold text-white" data-id="element-1961">celular o laptop</span>,
                sin oficina ni empleados
              </p>
            </div>

            <div className="bg-gray-900/60 border border-gray-800 rounded-xl p-5 flex items-start gap-4" data-id="element-1962">
              <div className="flex-shrink-0 w-10 h-10 bg-[#00f7fc]/10 rounded-lg flex items-center justify-center" data-id="element-1963">
                <RocketIcon className="w-5 h-5 text-[#00f7fc]" data-id="element-1964" />
              </div>
              <p className="text-gray-200 text-sm md:text-base leading-relaxed" data-id="element-1965">
                <span className="font-bold text-white" data-id="element-1966">
                  Sin experiencia técnica
                </span>{' '}
                requerida
              </p>
            </div>

            <div className="bg-gray-900/60 border border-gray-800 rounded-xl p-5 flex items-start gap-4 md:col-span-2" data-id="element-1967">
              <div className="flex-shrink-0 w-10 h-10 bg-[#00f7fc]/10 rounded-lg flex items-center justify-center" data-id="element-1968">
                <ZapIcon className="w-5 h-5 text-[#00f7fc]" data-id="element-1969" />
              </div>
              <p className="text-gray-200 text-sm md:text-base leading-relaxed" data-id="element-1970">
                Un sistema diseñado para{' '}
                <span className="font-bold text-white" data-id="element-1971">
                  implementarse rápidamente
                </span>
              </p>
            </div>
          </div>
        </section>

        {/* BEFORE YOUR CALL - STEPS */}
        <section data-id="element-1972">
          <div className="bg-gray-900/50 border border-gray-800 rounded-2xl p-6 md:p-10" data-id="element-1973">
            <div className="flex items-center gap-3 mb-8" data-id="element-1974">
              <div className="w-8 h-8 bg-[#00f7fc]/10 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-1975">
                <AlertTriangleIcon className="w-4 h-4 text-[#00f7fc]" data-id="element-1976" />
              </div>
              <h2 className="text-xl md:text-2xl font-black uppercase tracking-tight" data-id="element-1977">
                Antes de Tu Llamada, Haz Esto{' '}
                <span className="text-[#00f7fc]" data-id="element-1978">Ahora</span>
              </h2>
            </div>

            <div className="space-y-5" data-id="element-1979">
              {/* Step 1 */}
              <div className="flex items-start gap-4" data-id="element-1980">
                <div className="flex-shrink-0 w-10 h-10 bg-[#00f7fc] rounded-full flex items-center justify-center" data-id="element-1981">
                  <CalendarIcon className="w-5 h-5 text-black" data-id="element-1982" />
                </div>
                <div data-id="element-1983">
                  <p className="font-black text-white text-base md:text-lg" data-id="element-1984">
                    Paso 1
                  </p>
                  <p className="text-gray-300 text-sm md:text-base" data-id="element-1985">
                    Marca la fecha y hora en tu calendario ahora mismo
                  </p>
                </div>
              </div>

              {/* Step 2 */}
              <div className="flex items-start gap-4" data-id="element-1986">
                <div className="flex-shrink-0 w-10 h-10 bg-[#00f7fc] rounded-full flex items-center justify-center" data-id="element-1987">
                  <PhoneIcon className="w-5 h-5 text-black" data-id="element-1988" />
                </div>
                <div data-id="element-1989">
                  <p className="font-black text-white text-base md:text-lg" data-id="element-1990">
                    Paso 2
                  </p>
                  <p className="text-gray-300 text-sm md:text-base" data-id="element-1991">
                    Guarda este número en tu teléfono para no perder la llamada
                  </p>
                </div>
              </div>

              {/* Step 3 */}
              <div className="flex items-start gap-4" data-id="element-1992">
                <div className="flex-shrink-0 w-10 h-10 bg-[#00f7fc] rounded-full flex items-center justify-center" data-id="element-1993">
                  <MapPinIcon className="w-5 h-5 text-black" data-id="element-1994" />
                </div>
                <div data-id="element-1995">
                  <p className="font-black text-white text-base md:text-lg" data-id="element-1996">
                    Paso 3
                  </p>
                  <p className="text-gray-300 text-sm md:text-base" data-id="element-1997">
                    Busca un lugar tranquilo sin distracciones para la llamada
                  </p>
                </div>
              </div>

              {/* Step 4 */}
              <div className="flex items-start gap-4" data-id="element-1998">
                <div className="flex-shrink-0 w-10 h-10 bg-[#00f7fc] rounded-full flex items-center justify-center" data-id="element-1999">
                  <PenLineIcon className="w-5 h-5 text-black" data-id="element-2000" />
                </div>
                <div data-id="element-2001">
                  <p className="font-black text-white text-base md:text-lg" data-id="element-2002">
                    Paso 4
                  </p>
                  <p className="text-gray-300 text-sm md:text-base" data-id="element-2003">
                    Ten papel y lápiz listo para tomar notas importantes
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* TESTIMONIALS */}
        <section data-id="element-2004">
          <div className="text-center mb-8" data-id="element-2005">
            <div className="inline-flex items-center gap-2 bg-[#00f7fc]/10 border border-[#00f7fc]/30 rounded-full px-4 py-2 mb-4" data-id="element-2006">
              <QuoteIcon className="w-4 h-4 text-[#00f7fc]" data-id="element-2007" />
              <span className="text-sm font-semibold text-[#00f7fc] uppercase tracking-wide" data-id="element-2008">
                Lo Que Dicen Nuestros Estudiantes
              </span>
            </div>
          </div>

          <div className="grid md:grid-cols-3 gap-5" data-id="element-2009">
            {/* Testimonial 1 */}
            <div className="bg-gray-900/60 border border-gray-800 rounded-xl p-6 flex flex-col" data-id="element-2010">
              <div className="flex gap-1 mb-4" data-id="element-2011">
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-2012" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-2013" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-2014" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-2015" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-2016" />
              </div>
              <QuoteIcon className="w-6 h-6 text-[#00f7fc]/40 mb-3" data-id="element-2017" />
              <p className="text-gray-300 text-sm leading-relaxed flex-1" data-id="element-2018">
                "El sistema es claro, paso a paso y fácil de implementar. Me
                ayudó a entender cómo usar la IA en mi negocio de una manera que
                nunca había pensado."
              </p>
              <div className="mt-4 pt-4 border-t border-gray-800" data-id="element-2019">
                <p className="font-bold text-white text-sm" data-id="element-2020">Carlos M.</p>
                <p className="text-gray-500 text-xs" data-id="element-2021">Miami, FL</p>
              </div>
            </div>

            {/* Testimonial 2 */}
            <div className="bg-gray-900/60 border border-gray-800 rounded-xl p-6 flex flex-col" data-id="element-2022">
              <div className="flex gap-1 mb-4" data-id="element-2023">
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-2024" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-2025" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-2026" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-2027" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-2028" />
              </div>
              <QuoteIcon className="w-6 h-6 text-[#00f7fc]/40 mb-3" data-id="element-2029" />
              <p className="text-gray-300 text-sm leading-relaxed flex-1" data-id="element-2030">
                "Lo que más me gustó fue lo práctico que es. No es teoría, es
                acción inmediata desde el primer día."
              </p>
              <div className="mt-4 pt-4 border-t border-gray-800" data-id="element-2031">
                <p className="font-bold text-white text-sm" data-id="element-2032">Maria G.</p>
                <p className="text-gray-500 text-xs" data-id="element-2033">Hialeah, FL</p>
              </div>
            </div>

            {/* Testimonial 3 */}
            <div className="bg-gray-900/60 border border-gray-800 rounded-xl p-6 flex flex-col" data-id="element-2034">
              <div className="flex gap-1 mb-4" data-id="element-2035">
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-2036" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-2037" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-2038" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-2039" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-2040" />
              </div>
              <QuoteIcon className="w-6 h-6 text-[#00f7fc]/40 mb-3" data-id="element-2041" />
              <p className="text-gray-300 text-sm leading-relaxed flex-1" data-id="element-2042">
                "Nunca había usado IA para negocios. Ahora la uso todos los días
                y ha transformado completamente mi forma de trabajar."
              </p>
              <div className="mt-4 pt-4 border-t border-gray-800" data-id="element-2043">
                <p className="font-bold text-white text-sm" data-id="element-2044">Roberto S.</p>
                <p className="text-gray-500 text-xs" data-id="element-2045">Doral, FL</p>
              </div>
            </div>
          </div>
        </section>

        {/* CLOSING NOTE */}
        <section className="text-center pb-4" data-id="element-2046">
          <div className="inline-flex items-center gap-3 bg-[#00f7fc]/10 border border-[#00f7fc]/20 rounded-2xl px-6 py-4" data-id="element-2047">
            <CheckCircleIcon className="w-5 h-5 text-[#00f7fc] flex-shrink-0" data-id="element-2048" />
            <p className="text-gray-300 text-sm md:text-base" data-id="element-2049">
              Nos vemos en la llamada. Prepárate para tomar acción.
            </p>
          </div>
        </section>
      </main>

      <Footer data-id="element-2050" />
      <WhatsAppButton data-id="element-2051" />
    </div>;
}